<div class="order-term">
	@if (visibleLabel()) {
		<div class="complex">
			<label class="label">{{ 'orderTerms.label' | translate }}</label>

			<app-select
				[control]="control()"
				[items]="terms()"
				translationPrefix="orderTerms"
			/>
		</div>
	} @else {
		<div class="simple">
			<app-select
				[control]="control()"
				[items]="terms()"
				translationPrefix="orderTerms"
			/>
		</div>
	}
</div>
